import React from 'react';
import EnhancedBlogList from './EnhancedBlogList';

// Main BlogList component that uses the enhanced version
const BlogList = (props) => {
  return <EnhancedBlogList {...props} />;
};

export default BlogList;
